import { useRouter } from 'next/router';

import type { LegalPageSellersType } from '#__generated__/sanity';
import { LegalPageTemplate } from '#components/shared/templates/LegalPage';
import { PublicLayout } from '#components/shared/templates/PublicLayout';
import { Page as NextPage } from '#types/next';

type Props = {
  page: LegalPageSellersType;
};

const Page: NextPage<Props> = ({ page }: Props): JSX.Element => {
  const { isFallback } = useRouter();

  if (isFallback) {
    return (
      <div className="container mx-auto px-2 sm:px-4">
        <p className="q-text-body-base p-4">Loading&hellip;</p>
      </div>
    );
  }

  return <LegalPageTemplate page={page} />;
};

Page.options = {
  public: true,
  getLayout: (page) => <PublicLayout>{page}</PublicLayout>,
};

export { Page };
